import React from "react"
import style from "./selectDateRangeButton.module.scss"

const SelectDateRangeButton = (props) => {
    return (
        <div className={props.active ? style.activeSelectButton : style.selectButton}
             onClick={() => props.onclick(props.label)}>
            {props.label}
        </div>
    );
}

export default SelectDateRangeButton;

/*
*
tag='برند'                              :Label is the text above dropdown and its OPTIONAL
placeHolder='برن                            :The tag that will be returned everytime a function inside the component is called(REQUIRED)
label='برند'  د'               :Placeholder is the text inside dropdown button and is REQUIRED
dropdownList={array}                    :dropdownList is the items you wish to see when dropdown is clicked( also REQUIRED )
hasSearchBox={true}                     :You can define wether you want to have a search box or not
hasCheckbox={false}                     :Enables you to choose between single-select/multi-select modes
handleSelect={handleSelect}             :HandleSelect must be defined in parent component and will be given "tag" and "value" as function's parameters(REQUIRED)
handleSearch={handleSearch}             :HandleSearch is also defined in parent component and will be given "tag" and "value" as function's parameters
deleteSelectedItems={deleteAll}         :In case you want to delete all the selected values and it must be defined in parent(REQUIRED)
*
 */
